import { CONTRACT, useContract } from '@apeiron/contract'
import { useCallback } from 'react'

const useGetMakeupPrice = () => {
  const { call } = useContract(CONTRACT.DAILY_CHECK_IN.GET_MAKE_UP_PRICE)

  const getMakeupPrice = useCallback(
    async (days: number): Promise<string> => {
      const response = await call(days - 1)

      return response as string
    },
    [call]
  )

  const fetchMakeupPrices = useCallback(async (): Promise<string[]> => {
    const responses = await Promise.all(
      [1, 2, 3, 4, 5, 6].map(async (days: number) => {
        return getMakeupPrice(days)
      })
    )

    return responses
  }, [getMakeupPrice])

  return {
    getMakeupPrice,
    fetchMakeupPrices
  }
}

export default useGetMakeupPrice
